// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

export const zSubscribedPower = z.object({
    id: z.number().int(),
    description: z.string(),
    forLargeConsumptionSite: z.boolean(),
    power: z.number().int(),
    refCountryId: z.number().int()
});

export const zSiteType = z.object({
    id: z.number().int(),
    description: z.string(),
    translationKey: z.string(),
    isUnknown: z.boolean(),
    accommodation: z.boolean()
});

export const zSiteTypeLayout = z.object({
    id: z.number().int(),
    description: z.string(),
    translationKey: z.string().nullable(),
    type: zSiteType,
    unknown: z.boolean()
});

export const zOperationType = z.object({
    id: z.number().int(),
    name: z.string()
});

export const zOperationMission = z.object({
    id: z.number().int(),
    note: z.string(),
    description: z.string()
});

export const zRefMission = z.object({
    id: z.number().int(),
    note: z.string(),
    description: z.string(),
    stopMission: z.number().int(),
    code: z.string()
});

export const zDeliveryPointObject = z.object({
    code: z.string(),
    status: z.enum([
        'NOT_ENEDIS',
        'NOT_VERIFIED',
        'VALID',
        'FORCED_VALID',
        'PROCESSING',
        'FORCED_INVALID',
        'INVALID'
    ])
});

export const zHeatPumpManualUrl = z.object({
    language: z.string(),
    url: z.string()
});

export const zHeatPumpBrand = z.object({
    id: z.number().int(),
    name: z.string(),
    status: z.enum(['VALIDATED', 'NOT_VALIDATED']),
    creationDatetime: z.string(),
    personId: z.number().int()
});

export const zHeatPumpModel = z.object({
    id: z.number().int(),
    model: z.string(),
    modopFilePath: z.string().nullable(),
    modopUrls: z.array(zHeatPumpManualUrl),
    brand: zHeatPumpBrand,
    status: z.enum([
        'NOT_VALIDATED',
        'VALIDATED_NOT_ELIGIBLE',
        'VALIDATED_ELIGIBLE'
    ]),
    creationDatetime: z.string(),
    personId: z.number().int()
});

export const zHeatPumpLinkValue = z.object({
    linkedAppliance: z.enum([
        'WATER_HEATER',
        'HEATER',
        'HEATING_FLOOR',
        'PAC_ECS',
        'OTHER'
    ]),
    value: z.boolean()
});

export const zHeatPumpSiteDeclaration = z.object({
    id: z.number().int(),
    siteId: z.number().int(),
    model: zHeatPumpModel,
    creationDatetime: z.string(),
    personId: z.number().int(),
    linkedAppliances: z.array(zHeatPumpLinkValue)
});

export const zSubscriberMyVoltalisReadModel = z.object({
    canBeImpersonated: z.boolean(),
    access: z.union([
        z.literal('MY_VOLTALIS_2016'),
        z.literal('MY_VOLTALIS_2022')
    ]).nullable()
});

export const zSubscriberFlagsReadModel = z.object({
    privileged: z.boolean(),
    vip: z.boolean()
});

export const zSubscriberCompanyRequest = z.object({
    name: z.string(),
    corporateName: z.string()
});

/**
 * Estimated quantity of eligible appliances for a single appliance type.
 */
export const zApplianceEstimateItem = z.object({
    code: z.string().min(1),
    quantity: z.number().int().gte(0)
});

export const zUpdateSiteRequestPayload = z.object({
    layoutId: z.number().int().optional(),
    surface: z.number().int().optional(),
    eligibleApplianceNumber: z.number().int().gte(1).lte(255).optional(),
    applianceEstimates: z.array(zApplianceEstimateItem).optional(),
    heatPumpModels: z.array(z.object({
        heatpumpModelId: z.number().int()
    })).max(1).optional(),
    subscribedPowerTypeId: z.number().int().optional(),
    buildingOlderThan2Years: z.boolean().optional(),
    heatingSystemOlderThan2Years: z.boolean().optional(),
    grdId: z.number().int().optional(),
    subOwnerStatusTypeId: z.number().int().optional(),
    subscriberCompany: zSubscriberCompanyRequest.optional(),
    externalId: z.string().nullish()
});

/**
 * One line of a site's per-type appliance breakdown, with a display label (read-only).
 */
export const zApplianceEstimateLabelledItem = z.object({
    code: z.string().min(1),
    label: z.string(),
    quantity: z.number().int().gte(0)
});

export const zSiteId = z.number().int();

export const zReference = z.object({
    id: z.number().int(),
    description: z.string().nullable()
});

export const zCompany = z.object({
    id: z.number().int(),
    name: z.string(),
    fullName: z.string().nullable(),
    corporateName: z.string().nullable(),
    address: z.string().nullable(),
    postCode: z.string().nullable(),
    town: z.string().nullable(),
    type: zReference.nullable(),
    category: zReference.nullable(),
    authoriseMyvAccess: z.boolean().nullable(),
    codeEIC: z.string().nullable(),
    isSelectable: z.boolean().nullable(),
    parentIdList: z.string().nullable()
});

export const zElectricMeterReadModel = z.object({
    deliveryPoint: zDeliveryPointObject.nullable(),
    grd: zCompany.nullable(),
    name: z.string().nullable(),
    isRemoteMonitored: z.boolean().nullable(),
    isGlobalPowerAvailable: z.boolean()
});

export const zSubscriberId = z.number().int();

export const zSubscriberEmailAddress = z.object({
    id: z.number().int(),
    subscriberId: z.number().int().nullable(),
    mail: z.string(),
    personCreator: z.number().int(),
    valid: z.boolean().optional(),
    default: z.boolean()
});

export const zPhoneNumber = z.string();

export const zPhoneDto = z.object({
    id: z.number().int().nullish(),
    phone: zPhoneNumber.nullish(),
    valid: z.boolean().nullish(),
    default: z.boolean().nullish()
});

export const zSubscriberReadModel = z.object({
    id: zSubscriberId,
    firstname: z.string(),
    lastname: z.string(),
    title: zReference.nullable(),
    mails: z.array(zSubscriberEmailAddress),
    phones: z.array(zPhoneDto),
    company: zCompany.nullable(),
    myVoltalis: zSubscriberMyVoltalisReadModel,
    flags: zSubscriberFlagsReadModel
});

export const zSimpleCompany = z.object({
    id: z.number().int(),
    name: z.string()
});

export const zOperation = z.object({
    id: z.number().int(),
    name: z.string(),
    comments: z.string().nullable(),
    startDate: z.string().date(),
    endDate: z.string().date().nullable(),
    targetEndDate: z.string().date(),
    creationDate: z.string(),
    partner: zSimpleCompany,
    type: zOperationType,
    mission: zOperationMission.nullable()
});

export const zSiteReadModel = z.object({
    id: zSiteId,
    businessSegment: z.enum([
        'ORGANIZATION',
        'HOUSEHOLDER',
        'UNKNOWN'
    ]),
    surface: z.number().int().nullable(),
    subscribedPowerType: zSubscribedPower,
    subOwnerStatusType: zReference.nullable(),
    layout: zSiteTypeLayout.nullable(),
    partner: zCompany.nullable(),
    grd: zCompany.nullable(),
    deliveryPoint: zDeliveryPointObject.nullable(),
    electricMeter: zElectricMeterReadModel.nullable(),
    subscriber: zSubscriberReadModel.nullable(),
    operation: zOperation.nullable(),
    buildingOlderThan2Years: z.boolean().nullable(),
    heatingSystemOlderThan2Years: z.boolean().nullable(),
    heatPumpDeclarations: z.array(zHeatPumpSiteDeclaration),
    mandatoryInstallation: z.boolean(),
    subscriberOffer: z.union([
        z.literal('PREMIUM'),
        z.literal('BASIC'),
        z.literal('PREMIUM_PENDING_SIGNATURE')
    ]).nullable(),
    countryIsoCode: z.string(),
    showPartnerBadge: z.boolean(),
    phoningMission: zRefMission.nullable(),
    externId: z.string().nullable(),
    eligibleApplianceNumber: z.number().int().lte(255).nullable(),
    applianceEstimates: z.array(zApplianceEstimateLabelledItem).nullable(),
    deactivatedState: z.union([
        z.literal('DEACTIVATED_WITH_MYV'),
        z.literal('DEACTIVATED_WITHOUT_MYV')
    ]).nullable(),
    name: z.string().nullable(),
    wasEquippedWithTiko: z.boolean().nullish()
});

export const zAddressProvider = z.enum([
    'GOOGLE',
    'GOUVFR',
    'UNKNOWN'
]);

export const zAddressComplement = z.object({
    complement: z.string().nullable(),
    digicode: z.string().max(45).nullable(),
    building: z.string().nullable(),
    level: z.number().int().nullable(),
    stairway: z.string().nullable()
});

/**
 * Create a non-geocoded (incomplete) address
 */
export const zCreateManualAddressRequest = z.object({
    type: z.enum(['MANUAL']),
    addressLine: z.string(),
    zipCode: z.string(),
    city: z.string(),
    country: z.string()
}).and(zAddressComplement);

/**
 * Create an EXACT_MATCH address composed of a geocoded component only
 */
export const zCreateExactMatchAddressRequest = z.object({
    type: z.enum(['EXACT_MATCH']),
    addressProvider: zAddressProvider,
    geocodedAddress: z.record(z.unknown())
}).and(zAddressComplement);

/**
 * Create a NEARBY address composed of a geocoded component and manual input
 */
export const zCreateNearbyAddressRequest = z.object({
    type: z.enum(['NEARBY']),
    addressProvider: zAddressProvider,
    geocodedAddress: z.record(z.unknown()),
    addressLine: z.string(),
    zipCode: z.string(),
    city: z.string()
}).and(zAddressComplement);

export const zCreateAddressRequest = z.union([
    z.object({
        type: z.literal('MANUAL')
    }).and(zCreateManualAddressRequest),
    z.object({
        type: z.literal('EXACT_MATCH')
    }).and(zCreateExactMatchAddressRequest),
    z.object({
        type: z.literal('NEARBY')
    }).and(zCreateNearbyAddressRequest)
]);

export const zCreateSiteRequestPayload = z.intersection(z.unknown(), z.object({
    countryIsoCode: z.string(),
    address: zCreateAddressRequest,
    layoutId: z.number().int(),
    surface: z.number().int(),
    eligibleApplianceNumber: z.number().int().gte(1).lte(255).nullish(),
    applianceEstimates: z.array(zApplianceEstimateItem).optional(),
    heatPumpModels: z.array(z.object({
        heatpumpModelId: z.number().int()
    })).max(1),
    subscribedPowerTypeId: z.number().int().nullable(),
    buildingOlderThan2Years: z.boolean(),
    heatingSystemOlderThan2Years: z.boolean(),
    grdId: z.number().int().nullable(),
    operationId: z.number().int(),
    missionId: z.number().int(),
    subOwnerStatusTypeId: z.number().int(),
    subscriberId: z.number().int(),
    subscriberCompany: zSubscriberCompanyRequest.nullable(),
    externalId: z.string().nullable()
}));

/**
 * Update the address complement of an EXACT_MATCH address
 */
export const zUpdateExactMatchAddressRequest = zAddressComplement.and(z.object({
    type: z.enum(['EXACT_MATCH'])
}));

/**
 * Update the postal component of a NEARBY address
 */
export const zUpdateNearbyAddressRequest = zAddressComplement.and(z.object({
    type: z.enum(['NEARBY']),
    addressLine: z.string(),
    city: z.string(),
    zipCode: z.string()
}));

export const zExactMatchAddress = z.object({
    geocodingStatus: z.enum(['GEOCODED']),
    street: z.string(),
    streetNumber: z.string().nullable(),
    addressLine1: z.string(),
    zipCode: z.string(),
    city: z.string(),
    country: z.string(),
    geocodedFields: z.object({
        externalId: z.string().nullable(),
        score: z.number().nullable(),
        administrativeDivisions: z.array(z.string()),
        cityCode: z.string().nullable(),
        latitude: z.number(),
        longitude: z.number(),
        provider: zAddressProvider
    })
}).and(zAddressComplement);

export const zNearbyAddress = z.object({
    geocodingStatus: z.enum(['NEARBY']),
    addressLine1: z.string(),
    zipCode: z.string(),
    city: z.string(),
    country: z.string(),
    nearbyFields: z.object({
        externalId: z.string().nullable(),
        streetNumber: z.string().nullable(),
        street: z.string().nullable(),
        zipCode: z.string(),
        city: z.string(),
        score: z.number().nullable(),
        latitude: z.number(),
        longitude: z.number(),
        cityCode: z.string().nullable(),
        administrativeDivisions: z.array(z.string()),
        provider: zAddressProvider
    })
}).and(zAddressComplement);

/**
 * A geocoded address (exact or nearby); considered as fully exploitable
 */
export const zSiteAddress = z.union([
    z.object({
        geocodingStatus: z.literal('GEOCODED')
    }).and(zExactMatchAddress),
    z.object({
        geocodingStatus: z.literal('NEARBY')
    }).and(zNearbyAddress)
]);

/**
 * An incomplete address; either non-geocoded or broken (data inconsistency)
 */
export const zPartialAddress = z.object({
    geocodingStatus: z.enum(['NON_GEOCODED']),
    addressLine1: z.string().nullable(),
    zipCode: z.string().nullable(),
    city: z.string().nullable(),
    country: z.string()
}).and(zAddressComplement);

/**
 * A site with a geocoded (exact or nearby) address
 */
export const zSiteWithAddress = zSiteReadModel.and(z.object({
    address: zSiteAddress,
    partialAddress: zPartialAddress.nullable()
}));

/**
 * A site with a partial (or broken) address
 */
export const zSiteWithPartialAddress = zSiteReadModel.and(z.object({
    address: zSiteAddress.nullable(),
    partialAddress: zPartialAddress
}));

/**
 * A site with either an address or an incomplete address
 */
export const zSiteResponse = z.union([
    zSiteWithAddress,
    zSiteWithPartialAddress
]);

export const zApiError = z.object({
    code: z.string(),
    message: z.string().optional(),
    messageCode: z.string(),
    timestamp: z.string().datetime().optional(),
    path: z.string().optional(),
    data: z.record(z.unknown()).optional(),
    error: z.string().optional(),
    fieldErrors: z.record(z.unknown()).optional(),
    params: z.array(z.record(z.unknown())).optional()
});

export const zPublicPhotoId = z.string();

export const zPhotoFormat = z.enum(['HD', 'THUMBNAIL']);

export const zApplianceTypeAndLocalisation = z.object({
    type: z.string(),
    localisation: z.string().nullable()
});

export const zGeoLocation = z.object({
    latitude: z.number(),
    longitude: z.number(),
    simulated: z.boolean()
});

export const zHwModulatorId = z.number().int();

/**
 * Configuration-side modulator ID
 */
export const zCsModulatorId = z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

export const zHwMomboxId = z.number().int();

/**
 * Device serial number
 */
export const zDeviceSerial = z.string();

export const zPhotoSource = z.enum([
    'UNKNOWN',
    'VOLTINSTALL_CAMERA',
    'VOLTINSTALL_GALLERY'
]);

export const zPhotoDto = z.object({
    id: z.string(),
    siteId: zSiteId,
    number: z.number().int(),
    photoTypeRefId: z.number().int(),
    fileName: z.string(),
    personId: z.number().int(),
    personFirstName: z.string(),
    personLastName: z.string(),
    creationDateTime: z.string(),
    uploadDateTime: z.string(),
    hash: z.string(),
    hwModulatorId: zHwModulatorId.nullable(),
    csModulatorId: zCsModulatorId.nullable(),
    hwMomboxId: zHwMomboxId.nullable(),
    deviceSerial: zDeviceSerial.nullish(),
    url: z.string(),
    applianceTypeAndLocalisation: zApplianceTypeAndLocalisation.nullable(),
    source: zPhotoSource.nullable(),
    geolocation: zGeoLocation.nullable(),
    sectionId: z.number().int().nullish()
});

export const zAbuseReportDto = z.object({
    appointmentId: z.number().int(),
    abusiveOperatorType: z.string(),
    abuseReasonId: z.number().int(),
    comment: z.string()
});

export const zSitePotentialAbuseAppointmentDto = z.object({
    appointmentId: z.number().int(),
    startDateTime: z.string(),
    endDateTime: z.string()
});

export const zAbuseActionDto = z.object({
    id: z.number().int(),
    text: z.string()
});

export const zSitePotentialAbuseDto = z.object({
    appointments: z.array(zSitePotentialAbuseAppointmentDto),
    abuses: z.array(zAbuseActionDto)
});

export const zSurveyInterventionDto = z.object({
    interventionId: z.number().int(),
    startDatetime: z.string(),
    endDatetime: z.string(),
    endReasonId: z.number().int(),
    endReasonNote: z.string()
});

export const zInstallSatisfactionSurveyData = z.object({
    interventionId: z.number().int(),
    promptness: z.number().int(),
    installationCleanliness: z.number().int(),
    solutionExplanation: z.number().int(),
    technicianKindness: z.number().int(),
    technicianProfessionalism: z.number().int(),
    appliancesInstalled: z.enum([
        'TOTALLY',
        'PARTIALLY_REQUESTED_BY_SUBSCRIBER',
        'PARTIALLY_BY_TECHNICIAN',
        'NA'
    ]),
    givenDocuments: z.enum([
        'INSTALL_SHEET_AND_USER_MANUAL',
        'INSTALL_SHEET_ONLY',
        'USER_MANUAL_ONLY',
        'NONE',
        'DOES_NOT_KNOW'
    ]),
    subscriberRecommendsSolution: z.number().int(),
    generalComment: z.string()
});

export const zSiteSearchSmartFilterDto = z.object({
    field: z.enum([
        'subscriberId',
        'subscriberLastname',
        'subscriberFirstname',
        'email',
        'phone',
        'companyName',
        'siteId',
        'externId',
        'street',
        'postal',
        'town',
        'country',
        'deliveryPoint',
        'pilotHwId',
        'pilotCsId',
        'pilotSerial',
        'modSerial',
        'modHwId',
        'modCsId',
        'modNeuronId'
    ]),
    filterType: z.enum([
        'EQUALS',
        'CONTAINS',
        'STARTS_BY',
        'ENDS_BY'
    ]),
    value: z.string()
});

export const zSubscriberDetails = z.object({
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    email: z.string().email().nullish(),
    phoneNumber: zPhoneNumber.nullish(),
    hasDeliveryPoint: z.boolean().optional(),
    isLastSignatureBasic: z.boolean().optional()
});

export const zTransferSignatureRequest = z.object({
    upgradeToPremium: z.boolean().optional().default(false),
    acceptEnergyOffers: z.boolean().optional().default(false),
    acceptPartnerOffers: z.boolean().optional().default(false)
});

export const zTransferSignatureResponse = z.object({
    signatureUrl: z.string().url()
});

export const zTownInfoDto = z.object({
    id: z.number().int().nullish(),
    postCode: z.string().nullish(),
    inseeCode: z.string().nullish(),
    name: z.string().nullish(),
    country: zReference.optional()
});

export const zSimpleSubscriberDto = z.object({
    id: z.number().int().nullish(),
    civility: zReference.optional(),
    firstname: z.string().nullish(),
    lastname: z.string().nullish(),
    validPhoneList: z.array(zPhoneDto).nullish(),
    vip: z.boolean().nullish()
});

export const zSimpleCompanyDto = z.object({
    id: z.number().int().nullish(),
    name: z.string().nullish()
});

export const zSiteSearchDto = z.object({
    id: z.number().int().nullish(),
    name: z.string().nullish(),
    address: z.string().nullish(),
    addressComplement: z.string().nullish(),
    townInfo: zTownInfoDto.optional(),
    building: z.string().nullish(),
    level: z.number().int().nullish(),
    stairway: z.string().nullish(),
    digicode: z.string().nullish(),
    subscriber: zSimpleSubscriberDto.optional(),
    partner: zSimpleCompanyDto.optional(),
    nextAppointmentType: z.string().nullish(),
    isAccommodation: z.boolean().nullish()
});

export const zSubscriberLastname = z.string();

export const zSubscriberFirstname = z.string();

export const zEmail = z.string();

export const zCompanyName = z.string();

export const zExternId = z.string();

export const zSitePostalAddressDto = z.object({
    address: z.string().nullish(),
    addressComplement: z.string().nullish(),
    digicode: z.string().nullish(),
    building: z.string().max(45).nullish(),
    level: z.number().int().nullish(),
    stairway: z.string().nullish(),
    cityCode: z.string().nullish(),
    zipCode: z.string().nullish(),
    city: z.string().nullish()
});

export const zSiteGeocodedAddressCountry = z.object({
    label: z.string().nullish(),
    isoCode: z.string().nullish()
});

export const zSiteGeocodedAddressGeocoding = z.object({
    latitude: z.number().nullish(),
    longitude: z.number().nullish()
});

export const zSiteGeocodedAddressDto = z.object({
    id: z.number().int().nullish(),
    streetNumber: z.string().nullish(),
    street: z.string().nullish(),
    geocoding: zSiteGeocodedAddressGeocoding.optional(),
    zipCode: z.string().nullish(),
    city: z.string().nullish(),
    cityCode: z.string().nullish(),
    inseeCode: z.string().nullish(),
    administrativeDivision: z.array(z.string()).optional(),
    country: zSiteGeocodedAddressCountry.optional(),
    provider: z.string().nullish(),
    score: z.number().nullish(),
    externalId: z.string().nullish(),
    label: z.string().nullish()
});

export const zSiteSearchInfoDto = z.object({
    id: z.number().int(),
    externId: z.string().nullish(),
    deliveryPoint: z.string().nullish(),
    postalAddress: zSitePostalAddressDto.optional(),
    geocodedAddress: zSiteGeocodedAddressDto.optional()
});

export const zSubscriberSearchInfoDto = z.object({
    id: z.number().int().nullish(),
    firstname: z.string().nullish(),
    lastname: z.string().nullish(),
    phoneList: z.array(zPhoneNumber).nullish(),
    emailList: z.array(z.string()).nullish(),
    companyName: z.string().nullish()
});

export const zMomboxSearchInfoDto = z.object({
    csId: z.number().int().nullish(),
    hwId: z.number().int().nullish(),
    serialNumber: z.string().nullish()
});

export const zModulatorSearchInfoDto = z.object({
    csId: z.number().int().nullish(),
    hwId: z.number().int().nullish(),
    serialNumber: z.string().nullish(),
    neuronId: z.string().nullish()
});

export const zSearchInfoDto = z.object({
    siteSearchInfo: zSiteSearchInfoDto,
    subscriberSearchInfo: zSubscriberSearchInfoDto.optional(),
    pilotSearchInfo: zMomboxSearchInfoDto.optional(),
    modulatorSearchInfo: zModulatorSearchInfoDto.optional()
});

export const zIdentifiedLabel = z.object({
    id: z.number().int(),
    name: z.string()
});

export const zAvailableEndCallReason: z.ZodTypeAny = zIdentifiedLabel.and(z.object({
    children: z.array(z.lazy(() => zAvailableEndCallReason))
}));

export const zEndCallCommon = z.object({
    comment: z.string().nullish()
});

export const zEndCallSimpleConsultationRequest = zEndCallCommon.and(z.object({
    status: z.enum(['SIMPLE_CONSULTATION'])
}));

export const zGatewayShipmentReasonDto = z.object({
    id: z.number().int(),
    note: z.string()
});

export const zGatewayShipmentReasonsResponse = z.object({
    reasons: z.array(zGatewayShipmentReasonDto)
});

export const zGatewayModelDto = z.object({
    id: z.number().int(),
    note: z.string()
});

export const zGatewayModelTypesResponse = z.object({
    modelTypes: z.array(zGatewayModelDto)
});

export const zGatewayShipmentRequestHistoryDto = z.object({
    id: z.number().int(),
    gatewayModelId: z.number().int(),
    shipmentReasonId: z.number().int(),
    comment: z.string().nullable(),
    instant: z.string().datetime(),
    operatorCreationId: z.number().int()
});

export const zGatewayShipmentRequestHistoryResponse = z.object({
    requests: z.array(zGatewayShipmentRequestHistoryDto)
});

export const zSupportTypeDto = z.object({
    id: z.number().int(),
    note: z.string()
});

/**
 * Business code of the subscriber support need, from the "1. Demande adhérents" referential
 */
export const zSupportSubscriberNeedCode = z.enum([
    '1.1',
    '1.2',
    '1.3',
    '1.4',
    '1.5',
    '1.6'
]);

export const zSupportSubscriberNeedDto = z.object({
    code: zSupportSubscriberNeedCode,
    name: z.string()
});

export const zSupportSubscriberNeedsResponse = z.object({
    supportSubscriberNeeds: z.array(zSupportSubscriberNeedDto)
});

export const zSupportPostDto = z.object({
    supportTypeId: z.number().int(),
    comments: z.string().nullish(),
    supportSubscriberNeedCode: zSupportSubscriberNeedCode.nullish()
});

export const zRequestGatewayShipmentCommand = z.object({
    gatewayModelId: z.number().int().gte(1),
    shipmentReasonId: z.number().int().gte(1),
    comment: z.string().min(1)
});

export const zLimit = z.number().int().default(20);

export const zStreet = z.string();

export const zPostal = z.string();

export const zTown = z.string();

export const zCountry = z.string();

/**
 * Electric meter ID. (Also known as 'PDL' / 'PRM' or 'Point de livraison' in French)
 */
export const zDeliveryPoint = z.string();

export const zPilotHwId = z.number().int();

export const zPilotCsId = z.number().int();

export const zPilotSerial = z.string();

export const zModHwId = z.number().int();

export const zModCsId = z.number().int();

export const zModSerial = z.string();

export const zModNeuronId = z.string();

/**
 * Action to be taken regarding versioning.
 */
export const zVersionActionToBeTaken = z.enum([
    'NONE',
    'UPDATE_OTA',
    'UPDATE_USB'
]);

export const zMomboxHardwareVersion = z.object({
    id: z.number().int().optional(),
    description: z.string().nullish()
});

export const zMombox = z.object({
    hwId: z.number().int().nullish(),
    serialNumber: z.string().nullish(),
    csId: z.number().int().nullish(),
    siteId: z.number().int().nullish(),
    confSoftwareId: z.number().int().nullish(),
    softwareVersion: z.string().nullish(),
    operator: z.string().nullish(),
    lastIpDate: z.string().datetime().nullish(),
    csCreationDatetime: z.string().datetime().nullish(),
    refOperatingStatus: z.number().int().nullish(),
    location: z.string().nullish(),
    versionAction: zVersionActionToBeTaken.optional(),
    isUpdating: z.boolean().optional(),
    momboxHardwareVersion: zMomboxHardwareVersion.optional()
});

/**
 * Call type identifier (e.g. 237, 238)
 */
export const zCallTypeId = z.number().int();

export const zAvailableEndCallCallType = zIdentifiedLabel.and(z.object({
    id: zCallTypeId.optional()
}));

export const zAvailableEndCallReasonsResponse = z.object({
    callTypes: z.array(zAvailableEndCallCallType),
    callReasons: z.array(zAvailableEndCallReason)
});

/**
 * ID for a category of event / DAE (e.g 'Installation', 'Découplage', 'Prise de RDV', 'Finalisation du couplage'...)
 */
export const zEventCategoryId = z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

export const zEndCallConfirmEligibilityRequest = zEndCallCommon.and(z.object({
    status: z.enum(['CONFIRM_ELIGIBILITY']),
    callTypeId: zCallTypeId,
    closeEventCategoryIdOverride: zEventCategoryId.nullish()
}));

export const zEndCallNoTechnicianAvailabilityRequest = zEndCallCommon.and(z.object({
    status: z.enum(['NO_TECHNICIAN_AVAILABILITY']),
    callTypeId: zCallTypeId,
    closeEventCategoryIdOverride: zEventCategoryId.nullish()
}));

export const zEndCallNoSubscriberAvailabilityRequest = zEndCallCommon.and(z.object({
    status: z.enum(['NO_SUBSCRIBER_AVAILABILITY']),
    callTypeId: zCallTypeId,
    closeEventCategoryIdOverride: zEventCategoryId.nullish()
}));

/**
 * Code identifying the reason for subscription failure
 */
export const zSubscriptionFailureReasonCode = z.string();

export const zEndCallEligibilityKoRequest = zEndCallCommon.and(z.object({
    status: z.enum(['SUBSCRIPTION_FAILURE', 'UNREACHABLE']),
    callTypeId: zCallTypeId,
    reason: zSubscriptionFailureReasonCode
}));

export const zEndCallRequest = z.union([
    z.object({
        status: z.literal('CONFIRM_ELIGIBILITY')
    }).and(zEndCallConfirmEligibilityRequest),
    z.object({
        status: z.literal('NO_TECHNICIAN_AVAILABILITY')
    }).and(zEndCallNoTechnicianAvailabilityRequest),
    z.object({
        status: z.literal('NO_SUBSCRIBER_AVAILABILITY')
    }).and(zEndCallNoSubscriberAvailabilityRequest),
    z.object({
        status: z.union([
            z.literal('SUBSCRIPTION_FAILURE'),
            z.literal('UNREACHABLE')
        ])
    }).and(zEndCallEligibilityKoRequest),
    z.object({
        status: z.literal('SIMPLE_CONSULTATION')
    }).and(zEndCallSimpleConsultationRequest)
]);

/**
 * Priority level of the ticket
 */
export const zZendeskTicketPriority = z.enum([
    'URGENT',
    'HIGH',
    'NORMAL',
    'LOW'
]);

/**
 * Current status of the ticket
 */
export const zZendeskTicketStatus = z.enum([
    'NEW',
    'OPEN',
    'PENDING',
    'HOLD',
    'SOLVED',
    'CLOSED',
    'UNKNOWN'
]);

export const zZendeskUser = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    name: z.string().optional(),
    email: z.string().email().optional(),
    tags: z.array(z.string()).optional()
});

export const zZendeskGroup = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    name: z.string().optional(),
    description: z.string().optional()
});

export const zZendeskTicketDto = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    url: z.string().url(),
    externalId: z.string().nullable(),
    subject: z.string(),
    rawSubject: z.string(),
    description: z.string(),
    priority: zZendeskTicketPriority,
    status: zZendeskTicketStatus,
    recipient: z.string().email(),
    tags: z.array(z.string()),
    assignee: zZendeskUser,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    group: zZendeskGroup
});

export const zLocalDate = z.string().date();

export const zDelta = z.number().int();

export const zEndReasonDto = z.object({
    id: z.number().int(),
    note: z.string()
});

export const zObjectWithIdDto = z.object({
    id: z.number().int()
});

export const zAppointmentCancellationDto = z.object({
    appointmentCancellationReasonId: z.number().int(),
    comments: z.string().nullish()
});

export const zAppointmentTypeDto = z.object({
    name: z.string(),
    durationMinutes: z.number().int()
});

export const zAppointmentPartnerErrorDto = z.object({
    providerName: z.string(),
    reason: z.string(),
    fields: z.array(z.string())
});

/**
 * One line of a site's per-type appliance breakdown, with a display label (read-only).
 */
export const zApplianceLabelledItem = z.object({
    code: z.string().min(1),
    label: z.string(),
    quantity: z.number().int().gte(0)
});

export const zAppointmentPreparationDto = z.object({
    hardwareVersion: z.string(),
    hasVoltalisHardware: z.boolean(),
    radiatorsNumber: z.number().int(),
    installedDeviceNumber: z.number().int(),
    installedHeatPumpNumber: z.number().int(),
    actualAppliances: z.array(zApplianceLabelledItem).nullish()
});

export const zAppointmentFlexibleCountDto = z.object({
    nbFlexibleAppointment: z.number().int(),
    nbFlexibleAppointmentCloseToDeadline: z.number().int()
});

export const zFlexibleAppointmentRenewedDto = z.object({
    appointmentId: z.number().int(),
    comment: z.string()
});

export const zCancellationReasonTypeId = z.number().int();

export const zAppointmentCancellationReasonDto = z.object({
    id: z.number().int(),
    note: z.string(),
    appointmentCancellationReasonTypeId: z.number().int(),
    appointmentCancellationSectionId: z.number().int()
});

export const zValue = z.boolean().default(true);

export const zAppointmentUpdateInfosDto = z.object({
    comment: z.string(),
    operatorFirstName: z.string(),
    operatorLastName: z.string()
});

export const zSelfAppointmentDto = z.object({
    siteId: zSiteId,
    appointmentType: z.string(),
    link: z.string(),
    smsTemplateType: z.string(),
    emailType: z.string()
});

export const zAppointmentState = z.enum([
    'planned',
    'canceled',
    'finalized'
]);

export const zAppointmentId = z.number().int();

export const zAppointmentStatusDto = z.object({
    appointmentId: zAppointmentId,
    state: z.string(),
    endReasons: z.array(zEndReasonDto)
});

export const zAppointmentType = z.enum([
    'technicalMaintenance',
    'installation',
    'complexInstallation',
    'uninstall',
    'administrative',
    'installationVx',
    'qualityControl',
    'complianceControl',
    'installationVx_presentation',
    'installationVx_timePerHeater',
    'installationVx_communication',
    'installationVx_measureModule',
    'presentation',
    'upmarket',
    'installationFinalization',
    'pacInstallation',
    'pacReintervention',
    'pacMaintenance',
    'pacUpmarket',
    'pacFinalization',
    'pacUninstall'
]);

export const zUpsertAppointmentDto = z.object({
    id: zAppointmentId,
    state: zAppointmentState,
    type: zAppointmentType,
    serviceProviderId: z.number().int(),
    localStartDate: z.string().date(),
    localEndDate: z.string().date(),
    comment: z.string(),
    radiatorNumber: z.number().int().default(1),
    appointmentCancellationReasonId: z.number().int().nullish(),
    cancellationComment: z.string().nullish()
});

export const zFlexibleAppointmentPutDto = z.object({
    appointmentType: zAppointmentType,
    comment: z.string().nullish(),
    appointmentCancellationReasonId: z.number().int().nullish(),
    cancellationComment: z.string().nullish()
});

/**
 * Date-time without zone offset (matches java.time.LocalDateTime)
 */
export const zLocalDateTime = z.string();

export const zExistingAppointmentDto = z.object({
    id: zAppointmentId,
    type: zAppointmentType,
    localStartDate: zLocalDateTime,
    localEndDate: zLocalDateTime,
    creationDate: z.string().nullish(),
    appointmentConfirmedAt: z.string().nullish(),
    state: z.string(),
    comment: z.string().nullish(),
    isExternalAppointment: z.boolean(),
    flexible: z.boolean(),
    serviceProvider: zSimpleCompanyDto,
    appointmentCommitment: z.string(),
    creationPersonFirstName: z.string().nullish(),
    creationPersonLastName: z.string().nullish(),
    isCompromised: z.boolean().nullish(),
    technicianOnWay: z.boolean()
});

export const zSlotDto = z.object({
    slotId: z.string(),
    startDate: zLocalDateTime,
    endDate: zLocalDateTime,
    state: z.string(),
    serviceProviderId: z.number().int(),
    serviceProviderName: z.string(),
    tooClose: z.boolean()
});

export const zAppointmentAvailabilitiesDto = z.object({
    date: z.string().date(),
    slots: z.array(zSlotDto)
});

export const zAppointmentAvailabilitiesListDto = z.object({
    availabilities: z.array(zAppointmentAvailabilitiesDto),
    errors: z.array(zAppointmentPartnerErrorDto),
    totalSlots: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    flexibleAppointmentAvailable: z.boolean()
});

export const zNextAppointmentSummaryDto = z.object({
    id: zAppointmentId,
    localStartDate: zLocalDateTime,
    type: zAppointmentType,
    toEquipApplianceNumber: z.number().int(),
    toUninstallDeviceNumber: z.number().int(),
    toEquipHeatPumpNumber: z.number().int(),
    subscriberSlotStart: zLocalDateTime,
    subscriberSlotEnd: zLocalDateTime,
    technicianSlotStart: zLocalDateTime,
    technicianSlotEnd: zLocalDateTime,
    appointmentAccepted: z.boolean(),
    canAcceptAppointment: z.boolean(),
    isRenewed: z.boolean()
});

export const zAppointmentAvailabilityPreference = z.enum([
    'none',
    'morning',
    'afternon'
]);

export const zAppointmentAvailabilitySearchPostDto = z.object({
    startDate: zLocalDateTime,
    endDate: zLocalDateTime,
    appointmentType: zAppointmentType,
    availabilityPreference: zAppointmentAvailabilityPreference,
    serviceProvidersId: z.array(z.number().int())
});

export const zAppointmentAvailabilitySearchDtoRequest = z.object({
    startDate: zLocalDateTime,
    endDate: zLocalDateTime,
    appointmentType: zAppointmentType,
    slotId: z.number().int(),
    availabilityPreference: zAppointmentAvailabilityPreference,
    serviceProviderId: z.number().int()
});

export const zSlotType = z.enum([
    'UNAVAILABLE',
    'AVAILABLE',
    'AVAILABLE_3_STARS',
    'AVAILABLE_2_STARS',
    'AVAILABLE_1_STARS',
    'AVAILABLE_BEST'
]);

export const zAppointmentAvailabilitiesPostDto = z.object({
    startDate: zLocalDateTime,
    endDate: zLocalDateTime,
    appointmentType: zAppointmentType,
    slotId: z.number().int().nullish(),
    availabilityPreference: zAppointmentAvailabilityPreference,
    serviceProviderId: z.number().int(),
    comment: z.string().nullish(),
    slotState: zSlotType.nullish(),
    appointmentId: zAppointmentId.nullish(),
    appointmentCancellationReasonId: z.number().int().nullish(),
    cancellationComment: z.string().nullish(),
    reason: z.string().nullish()
});

export const zPartnerId = z.number().int();

export const zAppointmentPartnerDetailsDto = z.object({
    id: zPartnerId,
    name: z.string(),
    manuallyTriggeredAppointmentAllowed: z.boolean()
});

export const zUserInfo = z.object({
    username: z.string(),
    password: z.string()
});

export const zAccessTokenResponse = z.object({
    access_token: z.string(),
    refresh_token: z.string(),
    expires_in: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    scope: z.string(),
    jti: z.string(),
    token_type: z.string()
});

export const zMyVoltalisAccess = z.enum(['MY_VOLTALIS_2016', 'MY_VOLTALIS_2022']);

export const zPersonCompany = z.object({
    id: z.number().int().nullish(),
    note: z.string().nullish()
});

export const zPersonAccess = z.object({
    id: z.number().int().nullish(),
    content: z.string().nullish(),
    function: z.string().nullish(),
    service: z.string().nullish()
});

/**
 * Operator/person assigned to the subscriber when available.
 */
export const zPerson = z.object({
    id: z.number().int().nullish(),
    login: z.string().nullish(),
    firstname: z.string().nullish(),
    lastname: z.string().nullish(),
    type: zReference.nullish(),
    current: z.boolean().nullish(),
    creationDatetime: z.string().nullish(),
    personCreatorId: z.number().int().nullish(),
    principalCompanyId: z.number().int().nullish(),
    company: zPersonCompany.nullish(),
    canPerformInstallation: z.boolean().nullish(),
    personAccesses: z.array(zPersonAccess).nullish(),
    authorizedSiteIds: z.array(zSiteId).nullish(),
    authorizedSiteOrderingIds: z.array(z.number().int()).nullish(),
    allSiteAuthorized: z.boolean().nullish()
});

export const zPhone = z.object({
    id: z.number().int(),
    subscriberId: z.number().int(),
    phone: zPhoneNumber,
    isValid: z.number().int(),
    isDefault: z.number().int(),
    valid: z.boolean().optional(),
    default: z.boolean().optional(),
    comments: z.string().nullable(),
    personCreator: z.number().int().nullable()
});

/**
 * Legacy raw Subscriber model returned by `SiteController#getSubscriberFromSiteId`.
 */
export const zSubscriber = z.object({
    id: zSubscriberId,
    siteId: zSiteId.nullable(),
    operatorInCharge: zPerson.nullable(),
    civility: zReference.nullish(),
    firstname: z.string(),
    lastname: z.string(),
    login: z.string().nullish(),
    hasMyVoltalisAccess: z.boolean().nullish(),
    hasNewMyVoltalisAccess: z.boolean().nullish(),
    vip: z.boolean().nullish(),
    privileged: z.boolean().nullish(),
    validMailList: z.array(zSubscriberEmailAddress).optional(),
    validPhoneList: z.array(zPhone).optional(),
    myVoltalisAccess: zMyVoltalisAccess.nullish(),
    company: zCompany.nullish(),
    externalId: z.string().nullish(),
    civilityDescription: z.string().readonly().nullish()
});

/**
 * Installation test ID
 */
export const zInstallTestId = z.number().int().gte(1).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

/**
 * Installation test origin ID
 */
export const zInstallTestOriginId = z.number().int().gte(1).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

/**
 * Installation test result ID
 */
export const zInstallTestResultId = z.number().int().gte(1).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

/**
 * Reference installation test result ID
 */
export const zRefInstallTestResultId = z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
    z.literal(9),
    z.literal(10),
    z.literal(11),
    z.literal(12),
    z.literal(13),
    z.literal(14),
    z.literal(15),
    z.literal(16),
    z.literal(17),
    z.literal(18),
    z.literal(19),
    z.literal(20),
    z.literal(21)
]);

/**
 * Reference tested component ID: link (1), TIC (2), or CPL (3)
 */
export const zRefInstallTestComponentId = z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3)
]);

export const zInstallTestResult = z.object({
    id: zInstallTestResultId,
    numInterface: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    testTarget: z.string().nullable(),
    testResult: z.string().nullable(),
    isConnected: z.boolean().nullable(),
    measuredPower: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    refInstallTestResult: zRefInstallTestResultId.nullable(),
    refInstallTestResultDescription: z.string().nullable(),
    refInstallTestComponent: zRefInstallTestComponentId.nullable(),
    refInstallTestComponentDescription: z.string().nullable(),
    ticBiggerThanMeasure: z.boolean().nullable(),
    nokValidationReason: z.string().nullable()
});

/**
 * Tester person ID
 */
export const zPersonId = z.number().int().gte(1).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

export const zInstallTest = z.object({
    installTestId: zInstallTestId,
    siteId: zSiteId.nullable(),
    momboxId: zHwMomboxId.nullable(),
    modulatorId: zHwModulatorId.nullable(),
    modulatorCsId: zCsModulatorId.nullable(),
    testerName: z.string().nullable(),
    testerId: zPersonId.nullable(),
    dateSent: zLocalDateTime.nullable(),
    origin: zInstallTestOriginId.nullable()
});

export const zSiteConstraintsSummary = z.object({
    hasDefinitiveDeactivation: z.boolean().nullable(),
    hasTemporaryDeactivation: z.boolean().nullable(),
    hasLinkDeactivation: z.boolean().nullable(),
    hasPlanning: z.boolean().nullable(),
    hasModulationLimitation: z.boolean().nullable()
});

export const zButtonEvent = z.object({
    modulatorHwId: zHwModulatorId.nullable(),
    momboxHwId: zHwMomboxId.nullable(),
    dateMombox: zLocalDateTime.nullable(),
    dateArrival: zLocalDateTime.nullable()
});

export const zPersonPermissionContent = z.string();

export const zPersonPermissionFunction = z.string();

export const zPersonPermissionService = z.string();

export const zPersonPermission = z.object({
    id: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    content: zPersonPermissionContent.nullable(),
    function: zPersonPermissionFunction.nullable(),
    service: zPersonPermissionService.nullable()
});

export const zAutoDiagTest = z.object({
    start: zLocalDateTime.nullable(),
    end: zLocalDateTime.nullable(),
    result: z.enum([
        'OK',
        'NOK_NO_POWER',
        'NOK_NO_MODULATION',
        'NOK_UNREACHABLE',
        'NOK_DEVICE_UNKNOWN',
        'FAILED_BACKEND'
    ]).nullable()
});

export const zAutoDiagProgramming = z.object({
    mode: z.enum([
        'NORMAL',
        'CONFORT',
        'CONFORTMINUS1',
        'CONFORTMINUS2',
        'ECO',
        'ECOV',
        'HORS_GEL',
        'TEMPERATURE',
        'ARRET',
        'UNKNOWN',
        'ERROR'
    ]).nullable(),
    type: z.enum([
        'DEFAULT',
        'USER',
        'QUICK',
        'MANUAL',
        'UNKNOWN',
        'ERROR'
    ]).nullable(),
    failedToFetchMyVProgramming: z.boolean(),
    conform: z.enum([
        'CONFORM',
        'NOT_CONFORM',
        'FAILED'
    ]).nullable()
});

export const zAutoDiagMemo = z.object({
    actions: z.array(z.enum(['SYNCHRONIZE_MYV_PROGRAM', 'GET_SUPPORT'])).nullable(),
    content: z.string().nullable()
});

export const zAutoDiagSensor = z.object({
    serial: z.string().nullable(),
    hwId: zHwModulatorId.nullable(),
    csId: zCsModulatorId.nullable(),
    installationDatetime: zLocalDateTime.nullable()
});

export const zAutoDiagFailure = z.object({
    failedToFetchMyVEnergyManager: z.boolean()
});

/**
 * Configuration-side link id (CS_LINK.ID)
 */
export const zCsLinkId = z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

export const zAutoDiagDeviceInfo = z.object({
    canDiagnose: z.boolean(),
    serial: z.string().nullable(),
    myVName: z.string().nullable(),
    technicalName: z.string().nullable(),
    csLinkId: zCsLinkId.nullable(),
    hwId: zHwModulatorId.nullable(),
    hasEnergyManager: z.enum([
        'HAS_ENERGY_MANAGER',
        'NO_ENERGY_MANAGER',
        'ERROR_INFRA_VOLTALIS'
    ]).nullable(),
    applianceTypeTranslationKey: z.string().nullable(),
    roomTypeTranslationKey: z.string().nullable(),
    measuredPower: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    modulatorType: z.string().nullable()
});

export const zAutoDiagDevice = z.object({
    info: zAutoDiagDeviceInfo.nullable(),
    diagnostic: zAutoDiagTest.nullable(),
    programming: zAutoDiagProgramming.nullable(),
    memo: zAutoDiagMemo.nullable(),
    sensor: zAutoDiagSensor.nullable()
});

export const zAutoDiag = z.object({
    lastSync: zLocalDateTime.nullable(),
    devices: z.array(zAutoDiagDevice).nullable(),
    failures: zAutoDiagFailure.nullable(),
    disableAutoDiagFeature: z.boolean()
});

export const zApplianceReference = zReference.and(z.object({
    translation: z.string().nullish()
}));

/**
 * Configuration-side appliance ID
 */
export const zCsApplianceId = z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

/**
 * Hardware-side link ID
 */
export const zHwLinkId = z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

export const zAppliance = z.object({
    id: zCsApplianceId.nullable(),
    csLinkId: zCsLinkId.nullable(),
    hwLinkId: zHwLinkId.nullable(),
    appliance: zApplianceReference.nullable(),
    applianceReference: zApplianceReference.nullable(),
    nominalPower: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    localisation: z.string().nullable(),
    description: z.string().nullable(),
    creationDatetime: zLocalDateTime.nullable(),
    personCreationId: zPersonId.nullable(),
    lastModificationDatetime: zLocalDateTime.nullable(),
    personModificationId: zPersonId.nullable(),
    producer: z.boolean().nullable()
});

export const zLink = z.object({
    hwId: zHwLinkId.nullable(),
    csId: zCsLinkId.nullable(),
    interfaceName: z.string().nullable(),
    csLinkToCutId: zCsLinkId.nullable(),
    numInterface: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    measureType: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    appliances: z.array(zAppliance),
    measureIndex: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    maxPower: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    isGlobal: z.boolean().nullable(),
    isUpdated: z.boolean().nullable(),
    cutLink: z.boolean().readonly()
});

export const zMomboxConnection = z.object({
    momboxId: zHwMomboxId.nullable(),
    dateUpdate: zLocalDateTime.nullable(),
    lastIp: z.string().nullable(),
    status: z.string().nullable()
});

export const zMomboxGprs = z.object({
    volumeDate: z.string().date().nullable(),
    volumeSent: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    volumeReceived: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    alertDate: zLocalDateTime.nullable(),
    alertStatus: z.string().nullable()
});

export const zMomboxComponent = z.object({
    name: zReference.nullable(),
    brand: z.string().nullable(),
    serial: z.string().nullable(),
    note: z.string().nullable()
});

export const zDataInfo = z.object({
    id: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    idHwMombox: zHwMomboxId.nullable(),
    momboxIp: z.string().nullable(),
    type: zReference.nullable(),
    typeClass: zReference.nullable(),
    momboxDate: zLocalDateTime.nullable(),
    arrivalDate: zLocalDateTime.nullable(),
    frame: z.string().nullable()
});

export const zSoftwareUpdate = z.object({
    momboxHwId: zHwMomboxId.nullable(),
    datePrepared: zLocalDateTime.nullable(),
    dateSent: zLocalDateTime.nullable(),
    dateEnd: zLocalDateTime.nullable(),
    success: z.boolean().nullable(),
    label: z.string().nullable()
});

export const zMomboxCsId = z.number().int();

export const zMomboxSummary = z.object({
    hwId: zHwMomboxId.nullable(),
    serialNumber: zDeviceSerial.nullable(),
    csId: zMomboxCsId.nullable(),
    siteId: zSiteId.nullable(),
    confSoftwareId: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    softwareVersion: z.string().nullable(),
    operator: z.string().nullable(),
    lastIpDate: zLocalDateTime.nullable(),
    refOperatingStatus: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    location: z.string().nullable(),
    actionToBeTaken: z.string().nullable(),
    updating: z.boolean(),
    creationDatetime: zLocalDateTime.nullable()
});

export const zMomboxLastConnectionDate = z.object({
    momboxId: zMomboxCsId.nullable(),
    lastConnectionDate: z.string().datetime().nullable()
});

export const zDataHist = z.object({
    dateMeter: zLocalDateTime.nullable(),
    powerValue1: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    powerValue2: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    powerValue3: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    powerValue4: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    powerValue5: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    powerValue6: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable()
});

export const zAcquisitionRate = z.object({
    raw: z.number().nullable(),
    interpreted: z.number().nullable(),
    isECS: z.boolean().nullable()
});

export const zModulatorLastTemperature = z.object({
    idCsModulator: zCsModulatorId.nullable(),
    dateMeter: z.string().datetime().nullable()
});

export const zModulatorType = z.object({
    id: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    note: z.string().nullish(),
    nbTinf: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    nbMeasure: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    label: z.string().nullish(),
    measurementUnit: z.string().nullish(),
    measurementType: z.string().nullish()
});

export const zPairingStatus = z.enum([
    'finalized',
    'inProgress',
    'unpairable',
    'pairable',
    'unknownModulator',
    'modulatorOnWrongSite',
    'failedPlc',
    'failedGprs',
    'failedConfiguration',
    'notPaired',
    'tested',
    'testFailed',
    'checkNeeded'
]);

export const zModulator = z.object({
    hwId: zHwModulatorId.nullish(),
    csId: zCsModulatorId.nullish(),
    siteId: zSiteId.nullish(),
    serialNumber: zDeviceSerial.nullish(),
    neuronId: z.string().nullish(),
    modnum: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    momboxId: zHwMomboxId.nullish(),
    momboxCsId: zMomboxCsId.nullish(),
    refOperatingStatus: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    type: zModulatorType.nullish(),
    links: z.array(zLink).nullish(),
    pairingStatus: zPairingStatus.nullish(),
    location: z.string().nullish(),
    creationDatetime: zLocalDateTime.nullish()
});

export const zModulatorSummary = zModulator;

export const zLastSevenDaysResult = z.object({
    modulationNumber: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    modulationPerformancePercentage: z.number().nullable()
});

export const zModulatorWorkingCondition = z.object({
    csLinkId: zCsLinkId.nullable(),
    csModulatorId: zCsModulatorId.nullable(),
    acqRate: zAcquisitionRate.nullable(),
    lastPointDate: z.string().datetime().nullable(),
    linkModulationPerformance: zLastSevenDaysResult.nullable(),
    modulationEndDate: zLocalDateTime.nullable()
});

export const zPersonIdObject = z.object({
    id: zPersonId
});

export const zPersonSummary = z.object({
    id: zPersonId.nullish(),
    firstname: z.string().nullish(),
    lastname: z.string().nullish()
});

export const zEvent = z.object({
    id: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    title: z.string().nullable(),
    siteId: zSiteId.nullable(),
    subscriberId: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    eventCategory: zReference.nullable(),
    date: zLocalDateTime.nullable(),
    forecastDate: z.string().date().nullable(),
    description: z.string().nullable(),
    status: zReference.nullable(),
    priority: zReference.nullable(),
    operator: zPersonSummary.nullable(),
    operatorOwner: zPersonSummary.nullable(),
    closureDate: zLocalDateTime.nullable(),
    operatorClosure: zPersonSummary.nullable(),
    modificationDate: zLocalDateTime.nullable(),
    operatorDescription: z.string().nullable(),
    operatorOwnerDescription: z.string().nullable(),
    operatorClosureDescription: z.string().nullable(),
    isOpen: z.boolean().nullable(),
    origin: zReference.nullable(),
    createDateTime: zLocalDateTime.nullable()
});

export const zMinimalEvent = z.object({
    id: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    siteId: zSiteId.nullable(),
    eventCategory: zReference.nullable(),
    date: zLocalDateTime.nullable(),
    forecastDate: z.string().date().nullable(),
    description: z.string().nullable(),
    status: zReference.nullable(),
    priority: zReference.nullable(),
    operator: zPersonSummary.nullable(),
    closureDate: zLocalDateTime.nullable(),
    modificationDate: zLocalDateTime.nullable(),
    operatorDescription: z.string().nullable(),
    isOpen: z.boolean().nullable(),
    createDateTime: zLocalDateTime.nullable()
});

export const zEventNode: z.AnyZodObject = z.object({
    data: zMinimalEvent,
    truncated: z.boolean(),
    children: z.array(z.lazy(() => zEventNode))
});

/**
 * ID for an intance of an event / DAE (something that happened at a specific point in time).
 */
export const zEventId = z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

export const zEventLink = z.object({
    child: zEventId.nullable(),
    parent: zEventId.nullable(),
    operatorId: zPersonIdObject.nullable()
});

/**
 * OAuth2-style error body returned on authentication failures (401/403 raised by Spring Security)
 */
export const zAuthenticationError = z.object({
    error: z.string(),
    error_description: z.string().nullish()
});

export const zCurrentOperator = z.object({
    id: zPersonId,
    firstname: z.string().nullable(),
    lastname: z.string().nullable()
});

export const zLinkedAppliance = z.object({
    name: z.string().nullable(),
    csId: zCsModulatorId.nullable(),
    hwId: zHwModulatorId.nullable()
});

/**
 * Configuration-side third-party sensor ID
 */
export const zThirdPartySensorCsId = z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

/**
 * Device MAC address
 */
export const zMacAddress = z.string();

export const zThirdPartySensor = z.object({
    modulatorCsId: zThirdPartySensorCsId.nullable(),
    modulatorHwId: zHwModulatorId.nullable(),
    momboxCsId: zMomboxCsId.nullable(),
    macAddress: zMacAddress.nullable(),
    creationDatetime: zLocalDateTime.nullable(),
    appliances: z.array(zLinkedAppliance).nullable()
});

/**
 * VX device type
 */
export const zVxDeviceType = z.enum([
    'GATEWAY',
    'SMART_METER',
    'SMART_RELAY',
    'SMART_WIRE',
    'MODBUS',
    'IR_MODULE',
    'TEMPERATURE_SENSOR',
    'UNKNOWN'
]);

export const zVxTestResult = z.object({
    id: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    gatewayHwId: zHwMomboxId.nullable(),
    testResult: z.string().nullable(),
    serverReceptionDateTime: zLocalDateTime.nullable(),
    testStartGatewayDateTime: zLocalDateTime.nullable(),
    testEndGatewayDateTime: zLocalDateTime.nullable(),
    isModulationOk: z.boolean().nullable(),
    isAutoTestAllowed: z.boolean().nullable(),
    measuredPower: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable()
});

export const zTestedDevice = z.object({
    serialNumber: zDeviceSerial.nullable(),
    deviceType: z.string().nullable(),
    applianceName: z.string().nullable(),
    location: z.string().nullable(),
    testResults: z.array(zVxTestResult).nullable()
});

export const zSmartSwitchRexRequestTest = z.object({
    smartSwitchSerialList: z.array(zDeviceSerial)
});

/**
 * Legacy raw Subscriber model returned by `SiteController#getSubscriberFromSiteId`.
 */
export const zSubscriberWritable = z.object({
    id: zSubscriberId,
    siteId: zSiteId.nullable(),
    operatorInCharge: zPerson.nullable(),
    civility: zReference.nullish(),
    firstname: z.string(),
    lastname: z.string(),
    login: z.string().nullish(),
    hasMyVoltalisAccess: z.boolean().nullish(),
    hasNewMyVoltalisAccess: z.boolean().nullish(),
    vip: z.boolean().nullish(),
    privileged: z.boolean().nullish(),
    validMailList: z.array(zSubscriberEmailAddress).optional(),
    validPhoneList: z.array(zPhone).optional(),
    myVoltalisAccess: zMyVoltalisAccess.nullish(),
    company: zCompany.nullish(),
    externalId: z.string().nullish()
});

export const zLinkWritable = z.object({
    hwId: zHwLinkId.nullable(),
    csId: zCsLinkId.nullable(),
    interfaceName: z.string().nullable(),
    csLinkToCutId: zCsLinkId.nullable(),
    numInterface: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    measureType: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    appliances: z.array(zAppliance),
    measureIndex: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    maxPower: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullable(),
    isGlobal: z.boolean().nullable(),
    isUpdated: z.boolean().nullable()
});

export const zModulatorWritable = z.object({
    hwId: zHwModulatorId.nullish(),
    csId: zCsModulatorId.nullish(),
    siteId: zSiteId.nullish(),
    serialNumber: zDeviceSerial.nullish(),
    neuronId: z.string().nullish(),
    modnum: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    momboxId: zHwMomboxId.nullish(),
    momboxCsId: zMomboxCsId.nullish(),
    refOperatingStatus: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    type: zModulatorType.nullish(),
    links: z.array(zLinkWritable).nullish(),
    pairingStatus: zPairingStatus.nullish(),
    location: z.string().nullish(),
    creationDatetime: zLocalDateTime.nullish()
});

export const zModulatorSummaryWritable = zModulatorWritable;

/**
 * Site ID
 */
export const zSiteIdPathParam = zSiteId;

export const zServiceIdHeader = z.number().int();

export const zPathPublicPhotoId = zPublicPhotoId;

/**
 * Subscriber ID
 */
export const zSubscriberIdPathParam = zSubscriberId;

export const zSubscriberLastnameQueryParam = zSubscriberLastname;

export const zSubscriberFirstnameQueryParam = zSubscriberFirstname;

export const zEmailQueryParam = zEmail;

export const zPhoneQueryParam = zPhoneNumber;

export const zCompanyNameQueryParam = zCompanyName;

export const zExternIdQueryParam = zExternId;

/**
 * Maximum number of results. Default is 20.
 */
export const zLimitQueryParam = zLimit;

export const zStreetQueryParam = zStreet;

export const zPostalQueryParam = zPostal;

export const zTownQueryParam = zTown;

export const zCountryQueryParam = zCountry;

export const zDeliveryPointQueryParam = zDeliveryPoint;

/**
 * Site ID
 */
export const zSiteIdQueryParam = zSiteId;

export const zPilotHwIdQueryParam = zPilotHwId;

export const zPilotCsIdQueryParam = zPilotCsId;

export const zPilotSerialQueryParam = zPilotSerial;

export const zModHwIdQueryParam = zModHwId;

export const zModCsIdQueryParam = zModCsId;

export const zModSerialQueryParam = zModSerial;

export const zModNeuronIdQueryParam = zModNeuronId;

export const zMomboxSerial = zDeviceSerial;

export const zXVoltalisServiceIdHeader = z.number().int();

export const zLocalDateQueryParam = zLocalDate;

export const zAppointmentStateQueryParam = zAppointmentState;

export const zValueQueryParam = zValue;

/**
 * Appointment ID
 */
export const zAppointmentIdPathParam = zAppointmentId;

/**
 * delta
 */
export const zDeltaPathParam = zDelta;

/**
 * cancellationReasonTypeId
 */
export const zCancellationReasonTypeIdPathParam = zCancellationReasonTypeId;

/**
 * Installation test ID
 */
export const zInstallTestIdPathParam = zInstallTestId;

/**
 * Mombox hardware ID
 */
export const zMomboxHwIdPathParam = zHwMomboxId;

/**
 * Modulator hardware ID
 */
export const zModulatorHwIdPathParam = zHwModulatorId;

/**
 * Modulator configuration ID
 */
export const zModulatorCsIdPathParam = zCsModulatorId;

/**
 * Configuration-side link ID
 */
export const zCsLinkIdPathParam = zCsLinkId;

/**
 * Calling application service ID; defaults to the unknown application
 */
export const zOptionalXVoltalisServiceIdHeader = z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

export const zLinkCsIdPathParam = zCsLinkId;

/**
 * Mombox/pilot hardware ID
 */
export const zPilotHwIdPathParam = zPilotHwId;

export const zCsModulatorsQueryParam = z.array(zCsModulatorId);

export const zStartQueryParam = z.string();

export const zEndQueryParam = z.string();

/**
 * Event category ID
 */
export const zEventCategoryIdPathParam = zEventCategoryId;

/**
 * Event category ID
 */
export const zCategoryIdPathParam = zEventCategoryId;

/**
 * Event ID
 */
export const zEventIdPathParam = zEventId;

export const zThirdPartySensorCsIdPathParam = zThirdPartySensorCsId;

/**
 * Configuration-side modulator ID of the overridden appliance
 */
export const zApplianceCsIdPathParam = zCsModulatorId;

/**
 * Device serial number
 */
export const zSerialNumberPathParam = zDeviceSerial;

/**
 * OK
 */
export const zGetSiteV2Response = zSiteResponse;

/**
 * OK
 */
export const zUpdateSiteV2Response = zSiteResponse;

/**
 * OK
 */
export const zCreateSiteV2Response = zSiteResponse;

/**
 * OK
 */
export const zUpdateSiteAddressV2Response = zSiteAddress;

/**
 * OK
 */
export const zReplaceSiteAddressV2Response = z.union([
    zSiteAddress,
    zPartialAddress
]);

/**
 * OK
 */
export const zGetPhotosListResponse = z.array(zPhotoDto);

/**
 * OK
 */
export const zDownloadPhotoResponse = z.string();

/**
 * OK
 */
export const zGetApiSupportSiteBySiteIdAbuseResponse = zSitePotentialAbuseDto;

/**
 * OK
 */
export const zGetApiEmailSiteBySiteIdSubscriberBySubscriberIdLastSendingDatetimeForInvalidPdlEmailResponse = z.string();

/**
 * OK
 */
export const zGetApiSurveySiteBySiteIdInterventionsResponse = z.array(zSurveyInterventionDto);

/**
 * OK
 */
export const zGetApiSiteResponse = z.array(zSiteSearchDto);

/**
 * OK
 */
export const zPostApiSiteSearchResponse = z.array(zSearchInfoDto);

/**
 * OK
 */
export const zGetApiSiteBySiteIdVoltacallSubscriberDetailsResponse = zSubscriberDetails;

/**
 * No Content - Signature cancelled successfully or no ongoing signature found
 */
export const zDeleteApiSiteBySiteIdVoltacallSubscriberTransferSignatureResponse = z.void();

/**
 * OK - Ongoing signature found
 */
export const zGetApiSiteBySiteIdVoltacallSubscriberTransferSignatureResponse = zTransferSignatureResponse;

/**
 * OK - Signature generated successfully
 */
export const zPostApiSiteBySiteIdVoltacallSubscriberTransferSignatureResponse = zTransferSignatureResponse;

/**
 * OK
 */
export const zGetApiMomboxSerialBySerialSearchResponse = z.array(zMombox);

/**
 * OK
 */
export const zGetApiPhoningEndCallReasonsResponse = zAvailableEndCallReasonsResponse;

/**
 * OK
 */
export const zGetApiGatewayShipmentReasonsResponse = zGatewayShipmentReasonsResponse;

/**
 * OK
 */
export const zGetApiGatewayShipmentModelTypesResponse = zGatewayModelTypesResponse;

/**
 * OK
 */
export const zGetApiSiteBySiteIdGatewayShipmentHistoryResponse = zGatewayShipmentRequestHistoryResponse;

export const zPostApiPhoningSiteBySiteIdEndCallResponse = z.union([
    z.unknown(),
    z.void()
]);

/**
 * OK
 */
export const zGetApiReferenceTypeSupportResponse = z.array(zSupportTypeDto);

/**
 * OK
 */
export const zGetApiReferenceSupportSubscriberNeedsResponse = zSupportSubscriberNeedsResponse;

/**
 * Successfully retrieved tickets
 */
export const zGetTicketsBySiteIdResponse = z.array(zZendeskTicketDto);

/**
 * OK - List of existing appointment
 */
export const zGetAppointmentFilteredResponse = z.array(zExistingAppointmentDto);

/**
 * OK
 */
export const zGetAppointmentStatusResponse = zAppointmentStatusDto;

/**
 * No Content
 */
export const zCancelAppointmentResponse = z.void();

/**
 * OK
 */
export const zGetAppointmentResponse = zExistingAppointmentDto;

/**
 * No Content
 */
export const zCancelAppointmentWithoutSiteIdResponse = z.void();

/**
 * Created
 */
export const zNewAppointmentResponse = zObjectWithIdDto;

/**
 * No Content
 */
export const zCancelAppointmentPostResponse = z.void();

/**
 * No Content
 */
export const zCancelAppointmentPostWithoutsiteIdResponse = z.void();

/**
 * OK
 */
export const zGetAppointmentTypesAccordingToSiteEquipmentWithoutHeatersResponse = z.array(zAppointmentTypeDto);

/**
 * OK
 */
export const zGetAppointmentTypesAccordingToSiteEquipmentWithHeatersResponse = z.array(zAppointmentTypeDto);

/**
 * Created
 */
export const zGetPartnersAvailabilitiesResponse = zAppointmentAvailabilitiesListDto;

/**
 * OK
 */
export const zGetOperatorsPartnerAvailabilitiesResponse = zAppointmentAvailabilitiesListDto;

/**
 * Created appointment in external service
 */
export const zCreatePartnerAppointmentResponse = zObjectWithIdDto;

/**
 * Created forced appointment in external service
 */
export const zCreateForcedPartnerAppointmentResponse = zObjectWithIdDto;

/**
 * OK
 */
export const zGetSiteAppointmentPreparationResponse = zAppointmentPreparationDto;

/**
 * OK
 */
export const zCountFlexAppointmentAndCountAppointmentCloseDeadLineResponse = zAppointmentFlexibleCountDto;

/**
 * Created flexible appointment
 */
export const zCreateFlexibleAppointmentResponse = zObjectWithIdDto;

/**
 * Created flexible appointment
 */
export const zUpsertFlexibleAppointmentResponse = zObjectWithIdDto;

/**
 * OK
 */
export const zGetCancellationReasonResponse = z.array(zAppointmentCancellationReasonDto);

/**
 * OK
 */
export const zGetSiteNextAppointmentSummaryResponse = zNextAppointmentSummaryDto;

/**
 * OK
 */
export const zDeclareTechnicianOnWayToSiteResponse = zExistingAppointmentDto;

/**
 * OK
 */
export const zCancelTechnicianOnWayToSiteResponse = zExistingAppointmentDto;

/**
 * OK
 */
export const zGetAppointmentInfosResponse = z.array(zAppointmentUpdateInfosDto);

/**
 * List of service providers
 */
export const zGetSiteServiceProviderResponse = z.array(zAppointmentPartnerDetailsDto);

/**
 * OK
 */
export const zPostTokenResponse = zAccessTokenResponse;

/**
 * OK
 */
export const zGetLegacySubscriberFromSiteIdResponse = zSubscriber;

/**
 * Installation tests, ordered from most to least recent
 */
export const zGetInstallTestsBySiteIdResponse = z.array(zInstallTest);

/**
 * Installation tests, ordered from most to least recent
 */
export const zGetInstallTestsByMomboxHwIdResponse = z.array(zInstallTest);

/**
 * Installation tests, ordered from most to least recent
 */
export const zGetInstallTestsByModulatorHwIdResponse = z.array(zInstallTest);

/**
 * Installation tests, ordered from most to least recent
 */
export const zGetInstallTestsByModulatorCsIdResponse = z.array(zInstallTest);

/**
 * Installation test results
 */
export const zGetInstallTestResultsByTestIdResponse = z.array(zInstallTestResult);

/**
 * Site constraint summary
 */
export const zGetSiteConstraintsSummaryResponse = zSiteConstraintsSummary;

/**
 * Latest button events
 */
export const zGetLastButtonEventsResponse = z.array(zButtonEvent);

/**
 * Current person's permissions
 */
export const zGetPersonAccessResponse = z.array(zPersonPermission);

/**
 * Site automatic diagnostic
 */
export const zGetAutoDiagnosticResponse = zAutoDiag;

/**
 * Requested device diagnostic
 */
export const zRequestLinkAutoTestResponse = zAutoDiagDevice;

/**
 * Attached appliances
 */
export const zGetAppliancesFromCsLinkIdResponse = z.array(zAppliance);

/**
 * Attached links
 */
export const zGetLinksFromModulatorHwIdResponse = z.array(zLink);

/**
 * Mombox
 */
export const zGetMomboxResponse = zMombox;

/**
 * Mombox components
 */
export const zGetMomboxCompositionResponse = z.array(zMomboxComponent);

/**
 * Mombox data frames
 */
export const zGetMomboxDataInfosResponse = z.array(zDataInfo);

/**
 * Latest GPRS consumption and alert
 */
export const zGetLastMomboxGprsInfoResponse = zMomboxGprs;

/**
 * Latest mombox connection
 */
export const zGetMomboxLastConnectionResponse = zMomboxConnection;

/**
 * Latest software update
 */
export const zGetLastMomboxSoftwareUpdateResponse = zSoftwareUpdate;

/**
 * Site momboxes
 */
export const zGetMomboxListResponse = z.array(zMomboxSummary);

/**
 * Latest connection date per mombox
 */
export const zGetMomboxLastConnectionDateListResponse = z.array(zMomboxLastConnectionDate);

/**
 * Latest communication points
 */
export const zGetLastModulatorsTemperatureResponse = z.array(zModulatorLastTemperature);

/**
 * Hourly consumption points
 */
export const zGetDataHistHourlyResponse = z.array(zDataHist);

/**
 * Latest point; the body is empty when no point exists
 */
export const zGetLastPowerDataResponse = zDataHist.nullable();

/**
 * Modulator
 */
export const zGetModulatorResponse = zModulator;

/**
 * Acquisition rate
 */
export const zGetModulatorAcquisitionRate24hResponse = zAcquisitionRate;

/**
 * Acquisition rate
 */
export const zGetModulatorAcquisitionRate7dResponse = zAcquisitionRate;

/**
 * Acquisition rate
 */
export const zGetModulatorAcquisitionRate30dResponse = zAcquisitionRate;

/**
 * Attached modulators
 */
export const zGetModulatorListFromMomboxIdResponse = z.array(zModulator);

/**
 * Working conditions
 */
export const zGetModulatorLast7DaysWorkingConditionResponse = z.array(zModulatorWorkingCondition);

/**
 * Site modulators
 */
export const zGetModulatorListResponse = z.array(zModulatorSummary);

/**
 * Latest event in the category
 */
export const zGetLastEventFromSiteIdAndCategoryIdResponse = zEvent;

/**
 * Latest communication event
 */
export const zGetLastSubscriberCommunicationResponse = zEvent;

/**
 * Latest hardware configuration event
 */
export const zGetLastSiteConfigurationResponse = zEvent;

/**
 * First installation event
 */
export const zGetFirstInstallationResponse = zEvent;

/**
 * Events in the category
 */
export const zGetEventListFromCategoryIdResponse = z.array(zEvent);

/**
 * Event
 */
export const zGetEventFromEventIdResponse = zEvent;

/**
 * Created event
 */
export const zInsertEventResponse = zEvent;

/**
 * Created event link
 */
export const zCreateLinkBetweenTwoEventsResponse = zEventLink;

/**
 * Root event nodes
 */
export const zGetTreeEventsFromSiteIdResponse = z.array(zEventNode);

/**
 * Authentication tokens
 */
export const zPostTokenExternalResponse = zAccessTokenResponse;

/**
 * Next availability date and time
 */
export const zGetNextAvailabilityFromSiteIdResponse = zLocalDateTime;

/**
 * Current operator
 */
export const zGetMeResponse = zCurrentOperator;

/**
 * Third-party sensor
 */
export const zGetThirdPartyDetailsFromCsIdResponse = zThirdPartySensor;

/**
 * Association removed
 */
export const zDeleteThirdPartySensorApplianceAssociationResponse = z.void();

/**
 * Tested devices and their results
 */
export const zRetrieveVxRexTestsResponse = z.array(zTestedDevice);
